import React, { useEffect } from "react";
import Layout from "../../Layout";
import HeaderUser from "../HeaderUser";
import FormUserRegistration from "./FormUserRegistration";

const RegistrationUser = () => {
    useEffect(() => {
        const heading = document.querySelector("h1.form-title");
        if (heading) {
            heading.setAttribute("tabindex", "-1");
            heading.focus();
        }
    }, []);

return (
      <Layout>
        <HeaderUser />
        <main className="layout-container">
          <div 
            className="container"
            tabIndex="-1"
         >
            <div className="descript-container container-2">
              <h1 className="form-title g-clr" id="UserLevelTitle">
                User Registration
             </h1>
             <p>
              Use this form to pre-register individuals and ensure they receive an
              email notification once their account is created. They will be able to
              log in with a temporary password and follow a few simple steps to
              finalize their registration and start using the system immediately.
              Their contact information will be instantly available in the User
              Directory.
              </p>
            </div>
            <FormUserRegistration />
          </div>
        </main>
     </Layout>
  )
};

export default RegistrationUser;
